import { createFileRoute } from '@tanstack/react-router'

import { HeadToHeadPage } from '~/features/football-history/history-pages'
import { headToHeadQueryOptions } from '~/features/football-history/query-options'
import {
  parseHeadToHeadSearch,
  resolveHeadToHeadSearch,
} from '~/features/football-history/search-schema'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/_public/teams/compare')({
  validateSearch: search => parseHeadToHeadSearch(search, 'en'),
  head: () => seo({
    title: 'Head-to-head history | BallPeek',
    description: 'Scoped descriptive shared football history and recorded comparison.',
    pathname: '/teams/compare',
    locale: 'en',
  }),
  loaderDeps: ({ search }) => resolveHeadToHeadSearch(search),
  loader: async ({ context, deps }) => {
    await context.queryClient.prefetchQuery(
      headToHeadQueryOptions(deps),
    )
  },
  component: HeadToHeadRoute,
})

function HeadToHeadRoute() {
  return <HeadToHeadPage search={Route.useSearch()} />
}
